import type { ReviewOrderState } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { MY_REVIEWS_PATH, reviewWritePath } from '@/shared/config';
import { buttonVariants } from '@/shared/ui';

interface ReviewOrderActionProps {
  readonly state: ReviewOrderState | undefined;
}

const deadlineLabel = (date: string): string => {
  const [, month, day] = date.split('-');
  return `${Number(month)}월 ${Number(day)}일까지 쓸 수 있어요`;
};

/** 주문 화면의 후기 버튼 — 쓸 수 있으면 후기 쓰기와 마감일, 이미 썼으면 후기 보기, 그 밖에는 아무것도 두지 않는다. */
export const ReviewOrderAction = ({ state }: ReviewOrderActionProps): ReactElement | null => {
  if (state?.kind === 'WRITABLE') {
    return (
      <div className="flex items-center gap-2">
        <Link
          to={reviewWritePath(state.orderId)}
          className={buttonVariants({ variant: 'outline', size: 'sm' })}
        >
          후기 쓰기
        </Link>
        <span className="text-xs text-muted-foreground">{deadlineLabel(state.deadline)}</span>
      </div>
    );
  }
  if (state?.kind === 'WRITTEN') {
    return (
      <Link to={MY_REVIEWS_PATH} className={buttonVariants({ variant: 'ghost', size: 'sm' })}>
        후기 보기
      </Link>
    );
  }
  return null;
};
